import { useEffect } from 'react';
import { cookiesConstants, getCookie, removeCookie } from '@magalu/mixer-utils';
var useParentTrackIdCookie = function useParentTrackIdCookie() {
  var PARENT_TRACK_ID = cookiesConstants.PARENT_TRACK_ID;
  var initialTrackId = getCookie(PARENT_TRACK_ID);
  useEffect(function () {
    var checkAndRemoveCookie = function checkAndRemoveCookie() {
      var finalCookieValue = getCookie(PARENT_TRACK_ID);
      if (finalCookieValue && finalCookieValue === initialTrackId) {
        removeCookie(PARENT_TRACK_ID);
      }
    };
    return function () {
      checkAndRemoveCookie();
    };
  }, []);
};
export default useParentTrackIdCookie;